module.exports = __webpack_public_path__ + "static/media/04.4c96f1a8.png";